<script setup lang="ts">
withDefaults(defineProps<{
    selected?: boolean;
}>(), {selected: false});
</script>

<template>
  <div
    class="bg-gray-200 hover:bg-gray-100 transition-colors duration-100 py-0.5 px-3 rounded-xl cursor-pointer text-sm leading-tight flex items-center h-6"
    :class="{
      'bg-primary/15 text-primary font-medium border-primary border-[1px]': selected,
    }"
  >
    <span class="line-clamp-1">
      <slot />
    </span>
  </div>
</template>

<style scoped>

</style>
